module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "coming-soon-modal"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "font card-title"
  }, [_vm._v("¡Importante!")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font card-text"
  }, [_vm._v("\n      ¿Deseas cambiar la administración a " + _vm._s(_vm.item.name) + "?\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onCancel()
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onAccept()
      }
    }
  }, [_vm._v("Si")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d09babe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/ChangeAdminModal.vue
// module id = 783
// module chunks = 5